import React from 'react';
import LegalPage from '../../components/LegalPage';

export default function AffiliateDisclosure() {
  return (
    <LegalPage eyebrow="Legal" title="Affiliate Disclosure" updated="July 2025">
      <p>Waan Travel Pte. Ltd. (UEN 202418948C, STB Licence TA03795) operates www.cheapora.com (“Cheapora”) as a travel search and comparison platform.</p>
      <h2>Our commercial model</h2>
      <p>When live partner integrations are activated, Cheapora may receive a commission, referral fee or other compensation from selected travel partners when you click through our Website or complete a qualifying booking, quotation or purchase with those partners. This does not necessarily increase the price you pay.</p>
      <h2>Editorial independence</h2>
      <p>Where we highlight destinations, deals or providers, we aim to do so transparently. Affiliate compensation does not, in and of itself, dictate the availability of comparison results.</p>
      <h2>No approved partners at this time</h2>
      <p>As at the date of this publication, Cheapora is preparing to apply for affiliate and API partner relationships with travel providers. Any specific partner will only be named on the Website after the relationship has been formally approved.</p>
      <h2>Contact</h2>
      <p><a href="mailto:admin@waantravel.com">admin@waantravel.com</a></p>
    </LegalPage>
  );
}
